import React from 'react';

import Toast from 'CommonComponents/toast/Toast';

const ToastsContainer = ({ toasts }) => {
    return (
        !!toasts.length && (
            <div className="tw-w-96 tw-fixed tw-z-50 tw-right-0 tw-top-0 tw-p-4 tw-space-y-4">
                {toasts.map((toast) => (
                    <Toast key={toast.id} {...toast} />
                ))}
            </div>
        )
    );
};

export default ToastsContainer;
